module.exports = __webpack_public_path__ + "static/media/GothamRnd-Book.7cc51b92.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/fonts/GothamRnd-Book.woff
 ** module id = 1349
 ** module chunks = 0
 **/